"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Redirect_OnAllyKilledEventHandlerScript = void 0;
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_Redirect_OnAllyKilledEventHandlerScript = class Effect_Redirect_OnAllyKilledEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.AllyKilled) {
            return;
        }
        for (const target of handler.args.scriptArgs.redirectTo) {
            if (!container.isDeceased(target)) {
                return;
            }
        }
        container.cancelEffect(sequence, handler.args.scriptArgs.redirectEffectId);
    }
};
Effect_Redirect_OnAllyKilledEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Redirect_OnAllyKilled")
], Effect_Redirect_OnAllyKilledEventHandlerScript);
exports.Effect_Redirect_OnAllyKilledEventHandlerScript = Effect_Redirect_OnAllyKilledEventHandlerScript;
